'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variantSelected = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var variantSelected = exports.variantSelected = function variantSelected(selectedVariant) {
  // first, update the variant tab in the variant list
  var allVariantSelectors = document.querySelectorAll(_Dom2.default.windowsVariantSelect);
  [].concat((0, _toConsumableArray3.default)(allVariantSelectors)).forEach(function (variant) {
    if (variant.getAttribute('data-id') === selectedVariant.variantID) {
      variant.classList.add('variant-selected');
    } else {
      variant.classList.remove('variant-selected');
    }
  });
  // build target queries IF there is a base product ID set
  // this keeps us from updating ATC buttons unrelated to each other (upsells, in modals, etc)
  var atcQuery = selectedVariant.baseProduct ? '[data-base-product="' + selectedVariant.baseProduct + '"][data-atc]' : '[data-atc]';
  var atcInlineQuery = selectedVariant.baseProduct ? '[data-base-product="' + selectedVariant.baseProduct + '"][data-add-to-cart]' : '[data-add-to-cart]';
  // now update any ATC button to use the new variant ID
  var ATCs = document.querySelectorAll(atcQuery);
  [].concat((0, _toConsumableArray3.default)(ATCs)).forEach(function (atc) {
    atc.dataset.atc = selectedVariant.variantID;
  });
  // cart page uses different ATC triggers (so as not to open inline cart)
  var cartPageATCs = document.querySelectorAll(atcInlineQuery);
  cartPageATCs.forEach(function (atc) {
    atc.dataset.addToCart = selectedVariant.variantID;
  });
};